<script>
import $ from 'jquery';
import bootbox from '../bootbox.min';

export default {
  template: '#search-template',

  watch: {
    query() {
      this.searchData();
    },
    activeLogKey() {
      this.searchLog();
    },

    toggleAll(value) {
      this.selectedItems = (value) ? this.list.map((item) => item.id) : []
    },

    toggleAllByKey(value) {
      this.selectedItems = (value) ? this.list.map((item) => item[this.key]) : []
    },

    list() {
      this.selectedItems = [];
    },
  },

  data() {
    return {
      list: [],
      query: '',
      sortKey: '',
      reverse: -1,
      pagination: {},
      order: '',
      paginationIsActive: false,
      buttonsList: [],
      activeLogKey: '',
      shouldPaginate: true,

      loading: false,

      selectedItems: [],
      toggleAll: false,

      key: 'id',
      toggleAllByKey: false,
    };
  },

  mounted() {
    let shouldPaginate = $('#should-paginate').val();
    if (!!shouldPaginate) {
      this.shouldPaginate = shouldPaginate;
    }
    this.fetchStories();

    this.$root.$on('refresh-data-list', () => {
      this.selectedItems = [];
      this.list = [];
      this.fetchStories();
    });
  },

  methods: {
    handleToggleAllByKey(key) {
      this.key = key;
      this.toggleAllByKey = !this.toggleAllByKey;
    },

    loadOnlineAccountMatrixForUserIn: function (user_id, element) {
      let url = '/ajax/user/' + user_id + '/online-accounts/matrix';
      let token = $('meta[name="csrf-token"]').attr('content');
      $.post(url, {
        _token: token,
      }, function (data) {
        let online_account = data.name;

        if (online_account == undefined) {
          online_account = 'Nenhuma';
        }

        $(element).html(online_account);
      }).fail(function () {
        $(element).html('<i class="fa fa-times"></i>');
      });
    },

    searchLog: function (page_url = undefined) {
      var query = this.activeLogKey;
      this.fetchStories(page_url, query);
    },

    checkHasTemplates: function (templates) {
      if (templates.length > 0) {
        return 'Cuidado! Esse tema possui cartazes associados.';
      }
    },

    searchData: _.debounce(function () {
      var query = this.query;

      this.fetchStories(undefined, query);
    }, 300),

    isEmptyOrNull: function (data) {
      return (data == null || data == '');
    },

    selectRow: function (id) {
      var url = '/online/posters/' + id + '/edit';
      $(location).attr('href', url);
    },

    imageCategoryTag: function (image) {
      let src = image;

      if (this.isEmptyOrNull(image)) {
        src = '/img/category.png';
      }

      return '<img src="' + src + '" width="60" height="45" />';
    },

    imageUserTag: function (image) {
      let src = image;

      if (this.isEmptyOrNull(image)) {
        src = '/img/default.png';
      }

      return '<img src="' + src + '" width="50" height="50" />';
    },

    imageContentTag: function (image) {
      let src = image;

      if (this.isEmptyOrNull(image)) {
        src = '/img/content.png';
      }

      return '<img src="' + src + '" width="60" height="45" />';
    },

    getUrlBaseToPagination(page_url) {
      var url_current = window.location.href.replace('#', '').split('/');
      let route = $('input#route').val();

      if (route != undefined) {
        url_current = '/pagination/' + url_current[3] + '/' + route;
      } else {
        url_current = '/pagination/' + url_current[3];
      }

      page_url = page_url || url_current;
      return page_url;
    },

    fetchStories: function (page_url, query = null, isPagination = false) {
      if (this.shouldPaginate == true) {
        this.loading = true;

        let vm = this;
        page_url = this.getUrlBaseToPagination(page_url);
        query = query || this.query;

        $.ajax({
          type: 'GET',
          url: page_url,
          data: {field: vm.sortKey, order: vm.order, query: query},
          success(response) {
            var response = JSON.parse(response);
            vm.makePagination(response);
            vm.list = response.data;
          },
          complete() {
            vm.$nextTick().then(() => {
              vm.$root.lazyImages();
            });
            vm.loading = false;
          },
        });
      }
    },

    makePagination: function (data) {
      let pagination = {
        current_page: data.current_page,
        last_page: data.last_page,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
      };

      this.pagination = pagination;
      this.paginationIsActive = (data.total > data.per_page);
      this.returnButtons(pagination);
    },

    parseDate: function (date) {
      return new Date(date);
    },

    formatDate: function (date, format = 'dd/MM/yyyy HH:mm:ss') {
      if (this.isEmptyOrNull(date)) {
        return '';
      }
      date = this.parseDate(date);
      return date.toString(format);
    },

    formatDateWithoutHours: function (date) {
      return this.formatDate(date, 'dd/MM/yyyy');
    },

    formatCpf: function (cpf) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
    },

    formatCnpj: function (cnpj) {
      cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2');
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
      cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');
      return cnpj;
    },

    getCpfOrCnpj: function (cpf, cnpj) {
      if (cpf == undefined && cnpj == undefined)
        return '';

      if (typeof cpf == 'string') {
        return this.formatCpf(cpf);
      }

      return this.formatCnpj(cnpj);
    },

    isCpf: function (value) {
      return value.length === 11;
    },

    getAccountType(type) {
      return (type == 1) ? 'Pessoa jurídica' : 'Pessoa física';
    },

    getMatrixType($matrix) {
      return $matrix ? 'Matriz' : 'Filial';
    },

    getRateType(type) {
      if (type == 1) {
        return 'CARNÊ';
      }

      if (type == 2) {
        return 'DÉBITO EM CONTA';
      }

      return 'CHEQUE';
    },

    formatRate(rate) {
      return rate.replace('.', ',');
    },

    formatMoney(money) {
      let money_number = Number.parseFloat(money);
      let money_formatted = money_number.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
      return money_formatted;
    },

    getEntityType(matrix, type) {
      if (type == 1) {
        return this.getMatrixType(matrix);
      }

      return this.getAccountType(type);
    },

    setSortKey: function (key, pos) {
      this.reverse = this.reverse * -1;
      this.sortKey = key;
      var query = this.query;

      var up = '<i class="fa fa-level-up"></i>';
      var down = '<i class="fa fa-level-down"></i>';

      $('.fa.fa-level-up').remove();
      $('.fa.fa-level-down').remove();

      var text = $('.table th a').get(pos).innerHTML;

      if (this.reverse == 1) {
        $('.table th a').get(pos).innerHTML = text + ' ' + up;
        this.order = 'ASC';
      } else {
        $('.table th a').get(pos).innerHTML = text + ' ' + down;
        this.order = 'DESC';
      }

      this.fetchStories(undefined, query);
    },

    showContent: function (id) {
      showContent(id);
    },

    enable: function (id, message) {
      let vm = this;

      bootbox.confirm(message, function (result) {
        if (result) {
          var token = $('meta[name="csrf-token"]').attr('content');
          var _url = $('input[name="url"]').val();
          var namespace = $('input#namespace').val();
          var route = $('input#route').val();

          if (route != undefined) {
            _url = '/' + namespace + '/' + route;
          }

          $.ajax({
            type: 'POST',
            url: _url + '/enable/' + id,
            data: {_token: token},

            success: function (data, textStatus, xhr) {
              var message = JSON.parse(data);
              vm.$root.throwFlashMessage(message.type, message.message);

              if (xhr.status != 202) {
                vm.fetchStories();
              }
            },
          });
        }
      });
    },

    disable: function (id, message) {
      let vm = this;

      bootbox.confirm(message, function (result) {
        if (result) {
          var token = $('meta[name="csrf-token"]').attr('content');
          var _url = $('input[name="url"]').val();
          var namespace = $('input#namespace').val();
          var route = $('input#route').val();

          if (route != undefined) {
            _url = '/' + namespace + '/' + route;
          }

          $.ajax({
            type: 'POST',
            url: _url + '/' + id,
            data: {_token: token, _method: 'DELETE'},

            success: function (data, textStatus, xhr) {
              var message = JSON.parse(data);
              vm.$root.throwFlashMessage(message.type, message.message);

              if (xhr.status != 202) {
                vm.fetchStories();
              }
            },
          });
        }
      });
    },

    confirmResendEmail(route, message = 'Você tem certeza que deseja reenviar esse email?') {
      let vm = this;
      bootbox.confirm(message, function (result) {
        if (result) {
          let token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            type: 'POST',
            url: route,
            data: {_token: token, _method: 'POST'},

            success: function (data, textStatus, xhr) {
              let message = JSON.parse(data);
              vm.$root.throwFlashMessage(message.type, message.message);
            },
          });
        }
      });
    },

    confirm: function (id, message = 'Você tem certeza que deseja excluir esse registro?') {
      let complement = $('.theme-has-templates-' + id).html() || $('.campaign-has-files-' + id).html();

      if (complement !== undefined) {
        complement = '<br /> <strong>' + complement + '</strong>';
        message += complement;
      }

      let vm = this;

      bootbox.confirm({
        message: message,
        buttons: {
          confirm: {
            label: 'Sim',
            className: 'btn btn-outline-secondary',
          },
          cancel: {
            label: 'Não',
            className: 'btn btn-outline-secondary',
          },
        },
        callback: function (result) {
          if (result) {
            const token = $('meta[name="csrf-token"]').attr('content');
            let _url = $('input[name="url"]').val();
            const namespace = $('input#namespace').val();
            const route = $('input#route').val();
            const destroyRoute = $('input#destroyRoute').val();

            if (route !== undefined && !destroyRoute) {
              _url = '/' + namespace + '/' + route;
            }

            $.ajax({
              type: 'POST',
              url: _url + '/' + id,
              data: {_token: token, _method: 'DELETE'},

              success: function (data, textStatus, xhr) {
                let message = JSON.parse(data);
                vm.$root.throwFlashMessage(message.type, message.message);

                let counter = $('#items_counter');

                if (counter.length > 0) {
                  let value = parseInt(counter.text()) - 1;
                  counter.text(value);
                }

                if (xhr.status != 202) {
                  vm.fetchStories();
                }
              },
            });
          }
        },
      });
    },

    multipleConfirm: function () {
      let message = $('.multiple-removal').data('message');
      message = !message
          ? "Você tem certeza que deseja excluir esses registros?"
          : message;

      let vm = this;

      if ($('input[data-removal]:checked').length !== 0) {
        bootbox.confirm(message, function (result) {
          if (result) {
            let ids = [];
            $('input[data-removal]:checked').each(function () {
              ids.push($(this).val());
            });
            let token = $('meta[name="csrf-token"]').attr('content');
            let _url = $('input[name="url"]').val();
            let namespace = $('input#namespace').val();
            let route = $('input#route').val();

            if (route != undefined) {
              _url = '/' + namespace + '/' + route;
            }

            _url += '/destroy-multiple';

            let data = {
              items: ids,
            };

            $.ajax({
              type: 'POST',
              url: _url,
              data: {_token: token, _method: 'POST', items: data},

              success: function (data, textStatus, xhr) {
                let message = JSON.parse(data);
                vm.$root.throwFlashMessage(message.type, message.message);

                let counter = $('#items_counter');

                if (counter.length > 0) {
                  let newValue = parseInt(counter.text()) - ids.length;
                  counter.text(newValue);
                }

                if (xhr.status != 202) {
                  vm.fetchStories();
                }
              },
            });

          }
        });
      } else {
        bootbox.alert('Selecione as coordenadas para retirar a liberação...');
      }
    },

    allConfirm: function (route, message) {
      let vm = this;

      bootbox.confirm(message, function (result) {
        if (result) {
          let token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            type: 'POST',
            url: route,
            data: {_token: token, _method: 'POST'},

            success: function (data, textStatus, xhr) {
              let message = JSON.parse(data);
              vm.$root.throwFlashMessage(message.type, message.message);

              let counter = $('#items_counter');
              counter.text(0);

              if (xhr.status != 202) {
                vm.fetchStories();
              }
            },
          });
        }
      });
    },

    cancelInvoice: function (route, message) {
      let vm = this;

      bootbox.prompt(message, function (result) {
        if (result) {
          let token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            type: 'POST',
            url: route,
            data: {_token: token, _method: 'POST', justification: result},

            success: function (data, textStatus, xhr) {
              let message = JSON.parse(data);
              vm.$root.throwFlashMessage(message.type, message.message);

              if (xhr.status != 202) {
                vm.fetchStories();
              }
            },
          });
        }
      });
    },

    receiveInvoice: function (route, message) {
      let vm = this;

      bootbox.confirm(message, function (result) {
        if (result) {
          let token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            type: 'POST',
            url: route,
            data: {_token: token, _method: 'POST', justification: result},

            success: function (data, textStatus, xhr) {
              let message = JSON.parse(data);
              vm.$root.throwFlashMessage(message.type, message.message);

              if (xhr.status != 202) {
                vm.fetchStories();
              }
            },
          });
        }
      });
    },

    getBadgeColorById: function getBadgeColorById(id) {
      var classes = ['dark', 'danger', 'warning', 'info', 'success', 'primary'];
      return classes[id % classes.length];
    },

    translateUserCategory: function (category) {
      if (category === 'on') {
        return 'Online';
      } else if (category === 'off') {
        return 'Offline';
      }
    },

    compareDates: function (date) {
      var dataTema = Date.parse(date);
      var dataAtual = new Date();

      dataAtual.setHours(0, 0, 0, 0);

      if (dataTema.isBefore(dataAtual)) {
        return 'red';
      }
    },

    themeExpiresNull: function (date) {
      if (date == null) {
        return ('Não expira');
      } else {
        return this.formatDateWithoutHours(date);
      }
    },

    printedDateFormat: function (date) {
      if (!date) {
        return ('Nunca');
      } else {
        return this.formatDateWithoutHours(date);
      }
    },

    returnButtons: function (pagination) {
      var actualPage = pagination.current_page;
      var lastPage = pagination.last_page;
      var nextPageUrl = pagination.next_page_url;
      var prevPageUrl = pagination.prev_page_url;
      var baseUrl = null;

      if (nextPageUrl !== null || prevPageUrl !== null) {
        if (nextPageUrl === null) {
          baseUrl = prevPageUrl.split('=')[0] + '=';
        } else {
          baseUrl = nextPageUrl.split('=')[0] + '=';
        }

        var forward = 0;

        if (lastPage !== undefined && actualPage !== undefined) {
          if (actualPage + 3 > lastPage) {
            forward = lastPage;
          } else {
            forward = actualPage + 3;
          }

          var forwardButtonsArray = new Array();

          for (var i = actualPage; i <= forward; i++) {
            forwardButtonsArray.push({
              class: 'btn btn-default',
              click: baseUrl + i,
              disabled: i === actualPage,
              text: i,
            });
          }
        }

        var backwards = 0;

        if (actualPage !== undefined) {
          if (actualPage > 3) {
            backwards = 3;
          } else {
            backwards = actualPage - 1;
          }

          var backwardsButtonsArray = new Array();

          for (var i = 1; i <= backwards; i++) {
            backwardsButtonsArray.unshift({
              class: 'btn btn-default',
              click: baseUrl + (actualPage - i),
              disabled: i === actualPage,
              text: actualPage - i,
            });
          }
        }

        var fullList = backwardsButtonsArray.concat(forwardButtonsArray);
        var moreButton = {
          class: 'btn btn-default',
          click: undefined,
          disabled: true,
          text: '...',
        };

        if (fullList[fullList.length - 1].text !== lastPage) {
          fullList.push(moreButton);

          fullList.push({
            class: 'btn btn-default',
            click: baseUrl + (lastPage),
            disabled: false,
            text: lastPage,
          });
        }

        if (fullList[0].text !== 1) {
          fullList.unshift({
            class: 'btn btn-default',
            click: undefined,
            disabled: true,
            text: '...',
          });

          fullList.unshift({
            class: 'btn btn-default',
            click: baseUrl + 1,
            disabled: false,
            text: 1,
          });
        }
      }
      this.buttonsList = fullList;
    },

    updateInvoiceData(item) {
      this.$root.$emit('update-invoice-data', item);
    },

    showModalForSelectedItems(modalName) {
      if (this.selectedItems.length === 0) {
        return bootbox.alert('Selecione ao menos um item da lista...');
      }
      $(modalName).modal('show');
    },

    renewThemes() {
      if (this.selectedItems.length === 0)
        return bootbox.alert('Selecione ao menos uma campanha para renovar');

      this.$root.$emit('show-renew-themes-modal', this.selectedItems);
    },

    renewAllThemes() {
      let itemIds = this.list.map((item) => item.id);
      this.$root.$emit('show-renew-all-themes-modal', itemIds);
    },

    toggleSelected(item) {
      if (this.selectedItems.includes(item)) {
        this.selectedItems = this.selectedItems.filter((selected) => selected != item);
      } else {
        this.selectedItems.push(item);
      }
    },

    destroyAll(message, url) {
      bootbox.confirm(message, (result) => {
        if (result) {
          axios.post(url).then((response) => {
            this.$root.throwFlashMessage(response.data.type, response.data.message);
          }).catch(() => {
            this.$root.throwFlashMessage('danger', 'Houve um problema ao excluir os itens');
          }).finally(() => {
            this.list = [];
            this.selectedItems = [];
            this.fetchStories();
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/SearchTemplate.vue